




































import { Vue, Component, Prop } from "vue-property-decorator";
import * as data from "../_store/data.module";
import { bus } from "../main";
import * as user from "../_store/user.module";
import ActivitiesDocDialog from "./Dialogs/ActivitiesDocDialog.vue";
import RateDialog from "./Dialogs/RateDialog.vue";

@Component({
	components: {
		ActivitiesDocDialog,
		RateDialog
	}
})
export default class StoricoAttivita extends Vue {
	@Prop() soggetto!: string; //indica in base a quale soggetto sto guardando lo storico
	@Prop() idSoggetto!: number;
	@Prop() nomeSoggetto!: string;

	private listaStorico: any;
	private searchStorico: string;
	private loadingDataStorico: boolean;
	private headers: any;

	private showDocDialog: boolean;

	constructor() {
		super();
		this.listaStorico = [];
		this.searchStorico = "";
		this.loadingDataStorico = true;
		this.showDocDialog = true;
		this.headers = [
			{
				text: "Azienda",
				value: "denominazioneAzienda"
			},
			{
				text: "Tirocinante",
				value: "allievo"
			},
			{
				text: "Nome Attività",
				value: "nomeAttivitaIstituto"
			},
			{
				text: "Tipo Attività",
				value: "nomeTipoAttivita"
			},
			{
				text: "Documenti Attività",
				value: "documentiAttivita",
				sortable: false,
				width: "1%"
			},
			{
				text: "",
				value: "ratingAlternanza",
				sortable: false,
				width: "1%"
			}
		];
	}

	loadStoricoAttivita() {
		var instituteInfo = user.readInstituteInfo(this["$store"]);
		var payload = {
			idSoggetto: this.idSoggetto,
			soggetto: this.soggetto,
			idIstituto: instituteInfo.id
		};
		data
			.dispatchStoricoSoggetto(this["$store"], payload)
			.then(result => {
				this.listaStorico = result;
				this.loadingDataStorico = false;
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	created() {
		this.loadStoricoAttivita();

		bus.$on("destroyDocDialog", async () => {
			this.showDocDialog = false;
			await this.$nextTick();
			this.showDocDialog = true;
		});
	}
}
